/*
Codigo tomado del inicio de sesion de "schneider/portal de mantenimiento" para maquetar
*/

import React, { useRef, useState } from 'react'
import Router from '../../router';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

// Components
import { LoginFormContainer } from '../../components/molecules/forms/LoginForm/container'

// Styles
import {
  Container,
  SectionLeft,
  SectionRight,
  ContainerForm,
  CustomButtonBack,
} from './styles'

import { useTranslation } from 'react-i18next'
import { LanguageSelect } from '../../components/atoms/languageSelect'
import { IconCustomContainer, LanguageContainer } from '../styles'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import { ColorsContext } from '../../Context/ColorsContext'
import { Divider, Grid } from '@mui/material';

export const Login = () => {
	const { t } = useTranslation();
  const { colors, openBackDrop, contentRender } = React.useContext(ColorsContext);

  const [form, setForm] = React.useState({ username: '', roleId: null, password: '', reCaptchaToken: null })
  const [step, setStep] = useState(1);
  const [isLoading, setIsLoading] = React.useState(false)
  const [arrRolesUser, setArrRolesUser] = React.useState([]);
  const [messageError, setMessageError] = React.useState(null)

  const backStep = () => {
    setMessageError('');
    // setForm({ username: '', roleId: null, password: '', reCaptchaToken: null })
    if(arrRolesUser.length >= 2){
      setStep((prevStep) => prevStep - 1)
    }else {
      setStep((prevStep) => prevStep - 2)
    }
  }

  React.useEffect(() => {
    document.title = t('login.titleApp');
  }, [t])
  
  return (
    !contentRender ? (
      <>
        <Backdrop
          sx={{ color:"#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
          open={openBackDrop}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </>
    ) : (
      <Container>
        <SectionLeft imgUrl={`${Router.apiBaseUrl}${Router.appStaticAppearance}/bg_login.jpg`}>
        </SectionLeft>
        <SectionRight>
          <Grid container style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            <Grid item xs={3}>
              {step > 1 && (
                <CustomButtonBack startIcon={<ArrowBackIosNewIcon sx={{ fontSize: 13 }} />} onClick={() => backStep()} disabled={isLoading}>
                  {t('login.stepper.back')}
                </CustomButtonBack>
              )}
            </Grid>
            <Grid item xs={9}>
              <LanguageContainer insideApp={false}><LanguageSelect insideApp={false}/></LanguageContainer>
            </Grid>
          </Grid>
          <ContainerForm>
            <LoginFormContainer 
              step={step}
              setStep={setStep}
              form={form}
              setForm={setForm}
              messageError={messageError}
              setMessageError={setMessageError}
              arrRolesUser={arrRolesUser}
              setArrRolesUser={setArrRolesUser}
              backStep={backStep}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
            />
          </ContainerForm>
          <IconCustomContainer>
            {(colors?.iconUrl !== null && colors?.iconUrl !== "" && colors?.iconUrl !== undefined) && (
              <div className="logoBox">
                <img src={`${Router.apiBaseUrl}/${colors.iconUrl.toString()}`} alt='logo'/>
              </div>
            )}
            <Divider sx={{ borderRightWidth: 2, height: 56, m: 0.5, borderColor: "#d3d3d3" }} orientation="vertical" />
            <div className="logoBox">
              <img src={require("../../assets/images/schneider_white.png")} alt="schneider" />
            </div>
          </IconCustomContainer>
        </SectionRight>
      </Container>
    )
  )
}
